import * as tagsModule from './tags';
import { type ITagGroupConfig, type TagGroupType } from './types';

export const TAGS_GROUPS: { [key in TagGroupType]: ITagGroupConfig } = { ...tagsModule };
// TODO garage_garage_type
// TODO garage_material
// TODO hand_over
// TODO yeargte
// TODO year
// TODO composition
// TODO tour_3d
